import api from './api';

export interface MonitorStats {
  os: {
    platform: string;
    arch: string;
    uptime: number;
    hostname: string;
  };
  memory: {
    total: string;
    free: string;
    used: string;
    usagePercentage: number;
  };
  process: {
    uptime: number;
    heapUsed: string;
    rss: string;
  };
  cpu: {
    loadAvg: number[];
    count: number;
  };
  app: {
    activeRequests: number;
    totalRequests: number;
    avgResponseTime: number;
    requestsPerMinute: number;
  };
}

export const getMonitorStats = async (): Promise<MonitorStats> => {
  const response = await api.get('/admin/monitor/stats');
  return response.data;
};
